import config from 'appConfig';

export interface GoogleAdConfig {
  id: string;
  path: string;
  sizes: Array<Array<number>>;
}

//@ts-ignore
const googletag =  window.googletag || {};
googletag.cmd = googletag.cmd || [];

//@ts-ignore
const pbjs = window.pbjs || {};
pbjs.que = pbjs.que || [];
    
//@ts-ignore
window.adSlots = window.adSlots || {};

const generateTargetingTags = () => {
  const pathname = window.location.pathname;
  let category = "";
  
  if(pathname.split("/")[3]) {
    category = pathname.split("/")[3];
  }else if(pathname.split("/")[2]) {
    category = pathname.split("/")[2];
  } else {
    category = "undefined";
  }
    
  googletag.cmd.push(function () {
    googletag.pubads().setTargeting("Oglasi_Category", category);
    googletag.pubads().setTargeting("Oglasi_Environment",  config.environment);
    googletag.pubads().setTargeting("prebid", "demand manager");
  });

  //googletag.pubads().clearTargeting("interests");
  // Targeting 'colors' and 'fruits' are still present, while 'interests'
  // was cleared.

  //googletag.pubads().clearTargeting();
  // All targeting has been cleared.
}

const initializeAdSlot = (config : GoogleAdConfig) => {

  // check if the ad slot is already initialized
  //@ts-ignore
  if (window.adSlots[config.id]) {
    return;
  }

  pbjs.que.push(function () {
    googletag.cmd.push(function () {
      // check if the ad slot is already initialized previously in cmd queue cycle
      //@ts-ignore
      if (window.adSlots[config.id]) {
        return;
      }else{
        //@ts-ignore
        // throw flag that ad slot is initialized and waiting for ad response
        window.adSlots[config.id] = true;
      }

      var adSlot = googletag.defineSlot(
        config.path, 
        config.sizes, 
        config.id
      );

      if (adSlot) {
        adSlot.addService(googletag.pubads());
        //@ts-ignore
        window.adSlots[config.id] = adSlot;
      }

      googletag.display(config.id);
      pbjs.rp.requestBids({
          callback: function() {
              //@ts-ignore
              googletag.pubads().refresh([window.adSlots[config.id]]); //ili jednostavno (adSlot)?
          },
          //@ts-ignore
          gptSlotObjects: [window.adSlots[config.id]] //ili jednostavno (adSlot)?
      });
    });
  });
}

const initializeInterstitialAdSlot = (config : GoogleAdConfig) => {
   googletag.cmd.push(function () {
    // check if the ad slot is already initialized
    //@ts-ignore
    if (window.adSlots[config.id]) {
      return;
    }

    var adSlot = googletag.defineOutOfPageSlot(
      config.path,
      googletag.enums.OutOfPageFormat.INTERSTITIAL
    );

    if (adSlot) {
      adSlot.addService(googletag.pubads());
      //@ts-ignore
      window.adSlots[config.id] = adSlot;
    }

    //@ts-ignore
    googletag.pubads().refresh([window.adSlots[config.id]]);
  });
}

const destroyAdSlot = (config) => {
  
  // check if the ad slot is already destroyed
  //@ts-ignore
  if (!window.adSlots[config.id]) {
    return;
  }

  googletag.cmd.push(function () {
    
    // check if the ad slot is already destroyed previously in cmd queue cycle
    //@ts-ignore
    if (!window.adSlots[config.id]) {
      return;
    }
   
    //@ts-ignore
    googletag.destroySlots([window.adSlots[config.id]]);
    //@ts-ignore
    delete window.adSlots[config.id];

  });
}

export {
  generateTargetingTags,
  initializeInterstitialAdSlot,
  initializeAdSlot,
  destroyAdSlot
};


// WEBPACK FOOTER //
// ./src/services/googleAds.ts